const getCodeweaversConfiguration = ({ model, configVehicle, settings }) => {
  if (configVehicle) {
    const options =
      configVehicle?.car?.equipment?.packs &&
      configVehicle?.car?.equipment?.packs.map((pack: any) => {
        return {
          ...pack,
          description: pack.name,
          price: pack.price.listWithDiscount,
        }
      })

    const accessories = configVehicle?.car?.equipment?.options
      .filter((option: any) => option.type === 'Accessory')
      .map((option: any) => {
        return {
          ...option,
          description: option.name,
          price: option.price.listWithDiscount,
        }
      })

    return {
      defaultParameters: {
        deposit: {
          defaultValue:
            model?.finance?.deposit || settings?.configuration?.deposit,
        },
        annualMileage: {
          defaultValue:
            model?.finance?.mileage || settings?.configuration?.mileage,
        },
        term: {
          defaultValue: model?.finance?.term || settings?.configuration?.term,
        },
      },
      vehicle: {
        identifier: configVehicle?.car?.localCode, // required
        identifierType: 'Rams', // required
        description: {
          range: configVehicle?.car?.model, // required
          bodyStyle: configVehicle?.car?.body, // required
          grade: configVehicle?.car?.grade, // required
          engine: configVehicle?.car?.engine, // required
          colour: configVehicle?.car?.colour?.exterior?.name, // required
        },
        options: options || [],
        accessories: accessories || [],
        isNew: 'true', // required
        type: 'car', // required
        cashPrice: configVehicle?.price?.listWithDiscount, // required
        // customerSaving: null, // Optional
        // centreContribution: vehicle.centr_contr, // Optional
        linkBackUrl: configVehicle?.url, // required
        imageUrl: `${process.env.NEXT_PUBLIC_CCIS}/configuration/${configVehicle?.personal?.code}/exterior-04.png?width=768&height=516`,
      },
    }
  }

  if (model) {
    return {
      defaultParameters: {
        deposit: {
          defaultValue:
            model?.finance?.deposit || settings?.configuration?.deposit,
        },
        annualMileage: {
          defaultValue:
            model?.finance?.mileage || settings?.configuration?.mileage,
        },
        term: {
          defaultValue: model?.finance?.term || settings?.configuration?.term,
        },
        vehicle: {
          model: model?.finance?.name || model?.d4t4?.id,
          identifier: '',
          identifierType: 'Rams',
          type: 'car',
        },
      },
    }
  }

  return {
    defaultParameters: {
      annualMileage: {
        defaultValue:
          model?.finance?.mileage || settings?.configuration?.mileage,
      },
    },
  }
}

export default getCodeweaversConfiguration
